import api from '@/features/api/axios';
import { Signer } from '@/features/application/types/signers';

const getSigners = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string
): Promise<Signer[]> => {
  const { data } = await api.get(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers`
  );
  return data;
};

const addSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  email: string,
  index: number
): Promise<Signer> => {
  const { data } = await api.post(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers`,
    {
      email,
      index,
    }
  );
  return data;
};

const updateSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  signerId: string,
  email: string
): Promise<Signer> => {
  const { data } = await api.put(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers/${signerId}`,
    { email }
  );
  return data;
};

const deleteSigner = async (
  userShortId: string,
  mappingShortId: string,
  recordId: string,
  signerId: string
): Promise<void> => {
  await api.delete(
    `/api/users/${userShortId}/mappings/${mappingShortId}/records/${recordId}/signers/${signerId}`
  );
};

const notifyAdditionalSigners = async (
  userShortId: string,
  recordId: string,
  mappingShortId: string
): Promise<{ message: string; debugId: string }> => {
  const { data } = await api.post(
    `/api/email/notify-additional-signers/${userShortId}/${mappingShortId}/${recordId}`
  );
  return data;
};

export const signerApi = {
  getSigners,
  addSigner,
  updateSigner,
  deleteSigner,
  notifyAdditionalSigners,
};
